import { useMemo } from 'react';
import { SPECIES_LIST } from '../constants/species';

/**
 * Custom hook for managing species field data and options
 * Memoizes species options to prevent Select component re-mounts
 */
export const useSpeciesField = () => {
  // Memoize species options to prevent Select re-mount on every render
  const speciesOptions = useMemo(() => 
    SPECIES_LIST.map((species) => (
      <option key={species.code} value={species.code}>
        {species.code} - {species.label}
      </option>
    )), []);

  // Get species by code
  const getSpeciesByCode = (code) => {
    return SPECIES_LIST.find(s => s.code === code);
  };

  // Get display label for species code
  const getSpeciesDisplay = (code) => {
    const species = getSpeciesByCode(code);
    if (species) {
      return `${species.label} - [${species.code}]`;
    }
    return code || 'N/A';
  };

  return {
    speciesOptions,
    getSpeciesByCode,
    getSpeciesDisplay,
    SPECIES_LIST,
  };
};
